import * as React from "react";
import { imgSrc } from "src/common/upload/urlForDownload";
import { ImagePreview } from "src/components/ImagePreview";
import { zSidLabel } from "src/types";
import { ZMdmFile, zMdmFile } from "src/types/ZMdmFile";

import { KeyedImgFrame } from "../../attrEdits/AttrExternalImages/KeyedImgFrame";
import { ZTypeDef } from "../../ZAttrMeta";
import { ZAttrValue } from "../../ZAttrValue";
import { ZAttrViewImage } from "../ZAttrViewComponent";

/**
 * Поддерживаются различные типы данных: string, strOption и file
 * А так же массивы из них.
 */

type PropsAttrViewImage = {
  attrType: ZTypeDef;
  component?: ZAttrViewImage;
  value: ZAttrValue;
};

export const AttrViewImage: React.FC<PropsAttrViewImage> = (props) => {
  const { attrType, component, value } = props;
  let frames: KeyedImgFrame[] = [];
  if (value.type === "string" && !!value.value) {
    frames = [mkFrame(0, value.value)];
  } else if (value.type === "strOption" && !!value.value?.id) {
    frames = [mkFrame(0, value.value.id, value.value.label)];
  } else if (value.type === "file" && !!value.value?.id) {
    frames = [file2frame(value.value)];
  } else if (value.type === "array" && attrType.name === "array") {
    const itemType = attrType.item?.type.name;
    if (itemType === "file") {
      frames =
        value.value?.map((file, i) => {
          const res = zMdmFile.safeParse(file);
          return res.success ? file2frame(res.data) : mkFrame(i, "");
        }) ?? [];
    } else if (itemType === "strOption") {
      frames =
        value.value?.map((opt, i) => {
          const res = zSidLabel.safeParse(opt);
          return res.success
            ? mkFrame(i, res.data.id, res.data.label)
            : mkFrame(i, "");
        }) ?? [];
    } else if (itemType === "string") {
      frames =
        value.value?.map((url, i) => mkFrame(i, String(url || ""))) ?? [];
    }
  }
  if (frames.length === 0) {
    return null;
  }
  const maxWidth = component?.maxWidth ?? defaultMaxWidth;
  const maxHeight = component?.maxHeight ?? defaultMaxHeight;
  return (
    <ImagePreview
      frames={frames}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
      showCounter
    />
  );
};

const defaultMaxWidth = 100;
const defaultMaxHeight = 100;

const mkFrame = (index: number, url: string, label?: string) =>
  ({
    key: `${index}:${url}`, // нет гарантий, что url уникален
    url,
    label: label ?? url,
  }) satisfies KeyedImgFrame;

const file2frame = ({ id, name }: ZMdmFile) =>
  ({
    key: id,
    label: name,
    thumbUrl: imgSrc(id, "small"),
    url: imgSrc(id),
  }) satisfies KeyedImgFrame;
